import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Preloader from '../img/preloader.gif';
import Api from '../config/Api';
class Account extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: (localStorage.token ? localStorage.token : sessionStorage.token),
			email: '',
			firstname: '',
			lastname: '',
			newPassword: '',
			repeatPassword: '',
			currentPassword: '',
			isLoading: false,
			showPreloader: false,
			response: ''
		}
	}

	componentWillMount() {
		var self = this;
		Api.parseToken(this.state.token, function(response) {
			self.setState({
				originalEmail: response.email,
				email: response.email,
				firstname: response.firstname,
				lastname: response.lastname
			});
		});
	}

	onChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	onSubmitAccountChanges = (event) => {
		var self = this;
		event.preventDefault();
		this.setState({
			isLoading: true,
			showPreloader: true,
			response: ''
		}, function() {
			Api.changeUserSettings(JSON.stringify({ email: this.state.email, firstname: this.state.firstname, lastname: this.state.lastname, newPassword: this.state.newPassword, repeatPassword: this.state.repeatPassword, currentPassword: this.state.currentPassword, token: this.state.token, originalEmail: this.state.originalEmail }), function(response) {
				self.setState({
					response: response.response,
					showPreloader: response.showPreloader
				}, function() {
					if(response.errorCode === 0) {
						setTimeout(function(){
							localStorage.clear();
							sessionStorage.clear();
							window.location.replace('/');
						}, 2000);
					} else {
						self.setState({ isLoading: false });
					}
				});
			});
		});
	}

    render() {
    	return(
    		<div className="blockCtr myAccount br10 sh1">
    			<div className="blockHeader br10Top">
    				<Link to="/" className="backBtn br10TopLeft"><span className="fas fa-chevron-left"></span></Link>
    				<h3>My Account</h3>
    			</div>
    			<div className="blockInfo">
    				<form onSubmit={this.onSubmitAccountChanges} id="accountForm">
	    				<div className="row">
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
	    						<input type="text" className="input3 br5 anim1" maxLength="191" name="email" placeholder="Change e-mail address" onChange={this.onChange} value={this.state.email} />
	    					</div>
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
	    						<input type="password" className="input3 br5 anim1" maxLength="191" name="newPassword" placeholder="New password" onChange={this.onChange} value={this.state.newPassword} />
	    					</div>
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
	    						<input type="password" className="input3 br5 anim1" maxLength="191" name="repeatPassword" placeholder="Confirm new password" onChange={this.onChange} value={this.state.repeatPassword} />
	    					</div>
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
	    						<input type="password" className="input3 br5 anim1" maxLength="191" name="currentPassword" placeholder="Current password" onChange={this.onChange} value={this.state.currentPassword} />
	    					</div>
	    				</div>
	    				<div className="row">
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
	    						<input type="text" className="input3 br5 anim1" maxLength="191" name="firstname" placeholder="Change first name" onChange={this.onChange} value={this.state.firstname} />
	    					</div>
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}>
	    						<input type="text" className="input3 br5 anim1" maxLength="191" name="lastname" placeholder="Change last name" onChange={this.onChange} value={this.state.lastname} />
	    					</div>
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}></div>
	    					<div className="col-3 col-m-6" style={{paddingRight: 10, paddingLeft: 10}}></div>
	    				</div>
	    				<div className="row">
	    					<div className="col-6" style={{paddingLeft: 10}}>
	    						<img className="preloader" src={Preloader} alt="Fresenius Preloader" style={{display: (this.state.showPreloader ? 'inline-block' : 'none')}} />
	    						<p className="response">{this.state.response} &nbsp;</p>
	    					</div>
	    					<div className="col-6 ar">
								<input type="submit" className="submit1 br5 anim1" value="Save changes" style={{width: '100%', maxWidth: 200, marginRight: 10}} disabled={this.state.isLoading} />
	    					</div>
	    				</div>
	    			</form>
    			</div>
    		</div>
    	);
    }
}

export default Account;



// WEBPACK FOOTER //
// ./src/components/Account.js